import { LoadingService } from '@shared/services/loading.service';
import { Component, inject, OnDestroy } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { AuthService } from '@shared/services/auth.service';
import { SnackbarService } from '@shared/services/snackbar.service';
import { Subject, Observable, takeUntil } from 'rxjs';
import { MessageErrorResolver } from '../message-error-resolver';
import { ActivatedRoute, Router } from '@angular/router';
import { HandlerErrorMessage } from '../handler-error-message';

@Component({ template: `` })
export class BaseComponent implements OnDestroy {
  private unsubscriber = new Subject<void>();

  protected activatedRoute = inject(ActivatedRoute);
  protected authService = inject(AuthService);
  protected fb = inject(FormBuilder);
  protected handlerErrorMessage = inject(HandlerErrorMessage);
  protected messageErrorResolver = inject(MessageErrorResolver);
  protected router = inject(Router);
  protected snackbarService = inject(SnackbarService);

  // protected popupService = inject(PopupService);
  // protected alertService = inject(AlertService);
  // protected confirmationModalService = inject(ConfirmationModalService);

  // protected hasProfile(...profiles: ProfileType[]): boolean {
  //   if (profiles.includes('all' as ProfileType)) return true;

  //   const loggedUserProfiles = this.authService.getLoggedUserData()?.perfis;
  //   return profiles.some(profileSimpleName => {
  //     const profile = ProfileEnum[profileSimpleName as keyof typeof ProfileEnum]
  //     return loggedUserProfiles?.includes(profile);
  //   });
  // }

  takeUntilDestroy(): <T>(source: Observable<T>) => Observable<T> {
    return <T>(source: Observable<T>) => source.pipe(takeUntil(this.unsubscriber));
  }

  ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }
}
